import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteTipoDeAplicacionDeTarifaVehicular,
  getTiposDeAplicacionesDeTarifasVehiculares,
  patchTipoDeAplicacionDeTarifaVehicular,
  postTipoDeAplicacionDeTarifaVehicular,
} from 'api/catalogos/tipoDeAplicacionDeTarifasVehiculares';

// eslint-disable-next-line react/prop-types
const TipoDeAplicacionDeTarifasVehiculares = ({ permission }) => (
  <PlainCRUD
    title="Tipo de Aplicación"
    get={getTiposDeAplicacionesDeTarifasVehiculares}
    post={postTipoDeAplicacionDeTarifaVehicular}
    patch={patchTipoDeAplicacionDeTarifaVehicular}
    delete={deleteTipoDeAplicacionDeTarifaVehicular}
    defaultFields={defaultFields.descripcion}
    permission={permission}
  />
);

export default TipoDeAplicacionDeTarifasVehiculares;
